var render = function render(){var _vm=this,_c=_vm._self._c;return _c('bkf-action',{attrs:{"tooltip":_vm.tooltip},on:{"click":function($event){return _vm.$emit('click')}}},[_c('v-icon',[_vm._v("\n    navigate_before\n  ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }